<script>
  import accountApi from '@/api/account'
  import { events } from '@/helpers/gtm'

  const SUBSCRIPTION_GROUP_ID = 'b8933f8c-cd2d-4281-8d6e-9066c47429e1'
  const EVENT_NAME = 'sms_opt_in_current_member_US'

  export default {
    data() {
      return {
        emailFromUrl: '',
        email: '',
        phoneNumber: '',
        submitting: false,
        confirmed: false,
        error: null,
      }
    },
    computed: {
      resolvedEmail() {
        return this.emailFromUrl || this.email
      },
      buttonDisabled() {
        const phoneReady = this.phoneNumber.length >= 12
        if (this.emailFromUrl) {
          return !phoneReady
        }
        return !phoneReady || !this.email
      },
    },
    created() {
      if (this.$route.query.email) {
        this.emailFromUrl = this.$route.query.email
      }
    },
    methods: {
      async submit() {
        this.submitting = true
        this.error = null
        try {
          await accountApi.smsOptIn({
            email: this.resolvedEmail,
            phone: this.phoneNumber,
            subscriptionGroupId: SUBSCRIPTION_GROUP_ID,
            eventName: EVENT_NAME,
          })
          this.confirmed = true
          events.log({ name: 'sms opt-in submitted' })
        } catch (error) {
          this.error = error?.data?.message || 'Something went wrong. Please try again.'
        } finally {
          this.submitting = false
        }
      },
    },
  }
</script>

<template>
  <div class="min-h-screen flex items-center justify-center py-10 px-4" style="background-color: #eef4f0;">
    <!-- Form card -->
    <div v-if="!confirmed" class="w-full bg-white rounded-lg shadow-lg p-8 md:p-12" style="max-width: 700px;">
      <BasePanelWarning v-if="error" class="mb-6">
        {{ error }}
      </BasePanelWarning>

      <h1 class="font-heading text-4xl text-center leading-tighter mb-3">
        SMS Signup
      </h1>
      <p class="text-center text-sm text-gray-dark mb-6">
        Stay up to date and be the first to know about specials, savings, and
        customization periods!
      </p>

      <BaseForm v-slot="{ inputsEnabled }">
        <BaseInputPhoneNumber
          v-model="phoneNumber"
          :disabled="!inputsEnabled"
          class="mb-4"
        />

        <div v-if="!emailFromUrl" class="mb-6">
          <BaseInput
            v-model="email"
            type="email"
            :disabled="!inputsEnabled"
            class="mb-1"
          >
            Email Address
          </BaseInput>
          <p class="text-3xs text-gray-dark leading-snug mt-1">
            Email address is used to connect your phone number to your subscription account.
          </p>
        </div>

        <BaseButton
          :disabled="buttonDisabled"
          class="w-full mb-4"
          @click="submit"
        >
          Sign Up
        </BaseButton>
      </BaseForm>

      <p class="text-3xs text-gray-dark leading-snug">
        By submitting this form, you confirm you want to receive automated promotional and
        personalized marketing text messages (e.g. cart reminders) from Alltrue at the cell number
        used when signing up. Consent is not a condition of any purchase. Reply HELP for help and
        STOP to cancel. Message frequency varies. Message &amp; data rates may apply.
        <BaseLinkStyled :to="{ name: 'PagePrivacy' }" target="_blank">View Privacy Policy</BaseLinkStyled>
        &amp;
        <BaseLinkStyled :to="{ name: 'PageTermsOfUse' }" target="_blank">Terms</BaseLinkStyled>.
      </p>
    </div>

    <!-- Success card -->
    <div v-else class="w-full bg-white rounded-lg shadow-lg p-8 md:p-12 text-center" style="max-width: 700px;">
      <div class="flex justify-center mb-4">
        <BaseIcon :size="12" class="text-primary">
          <IconCheckmarkCircle />
        </BaseIcon>
      </div>
      <h1 class="font-heading text-4xl leading-tighter mb-4">
        Check Your Phone!!
      </h1>
      <p class="text-sm text-gray-dark leading-relaxed">
        We sent a text to your number. Reply Y to confirm your opt-in and start receiving
        updates about customization windows, exclusive deals, and more.
      </p>
    </div>

    <BaseSpinner v-if="submitting" overlay="fixed" overlay-color="white" class="z-10" />
  </div>
</template>
